import { STATUS_TEXT } from '../constants/orders';

export const getText = status => STATUS_TEXT[status] || '';

export default getText;
